import { useEffect, useState, useRef } from 'react';

export default function useAudienceState() {
    
    const [isSaved, setIsSaved] = useState(JSON.parse(localStorage.getItem('am:audience:is_saved')) || true);
    const [unsavedModalIsOpen, setUnsavedModalIsOpen] = useState(false);
    const [onClickContinueHandler, setOnClickContinueHandler] = useState(null);
    const [onClickSaveHandler, setOnClickSaveHandler] = useState(null);

    const saved = (is_saved) => {
        setIsSaved(is_saved);
    }

    const continueHandler = (handler) => {
        setOnClickContinueHandler(handler);
    }

    const saveHandler = (handler) => {
        setOnClickSaveHandler(handler);
    }

    const toggleUnsavedDataModal = () => {
        if (unsavedModalIsOpen) {
            // Set this to null or useEffect for the handler doesn't trigger
            setOnClickContinueHandler(null);
        }
        setUnsavedModalIsOpen(!unsavedModalIsOpen);
    };

    const unsavedAudience = (continueHandler) => {
        if (continueHandler) {
            setOnClickContinueHandler(continueHandler);
        }
    }

    const onModalContinue = () => {
        clearEditingStates();
        if(unsavedModalIsOpen){
            toggleUnsavedDataModal();
        }
        onClickContinueHandler();
    }

    const clearEditingStates = () => {
        localStorage.removeItem("am:audience:audience_state");
    }

    useEffect(() => {
        if (!isSaved && onClickContinueHandler) {
            toggleUnsavedDataModal();
        } else if (onClickContinueHandler) {
            onModalContinue();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClickContinueHandler]);

    useEffect(() => { 
        localStorage.setItem('am:audience:is_saved', JSON.stringify(isSaved));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSaved]);

    const audience_state_output = {
        isSaved: isSaved,
        unsavedModalIsOpen: unsavedModalIsOpen,
        onClickContinueHandler: onClickContinueHandler,
        onClickSaveHandler: onClickSaveHandler,
        // eslint-disable-next-line
        saved: saved,
        toggleUnsavedDataModal: toggleUnsavedDataModal,
        saveHandler: saveHandler,
        continueHandler: continueHandler,
        unsavedAudience: unsavedAudience,
        clearEditingStates: clearEditingStates,
    };

    const previousValues = useRef(audience_state_output);
    const [updatedValues, setUpdatedValues] = useState(audience_state_output);
  
    useEffect(() => {
      if (
        previousValues.current.isSaved === isSaved &&
        previousValues.current.unsavedModalIsOpen === unsavedModalIsOpen
      ) {
        return;
      }
  
      // update stored values & trigger re-render
      previousValues.current = audience_state_output;
      setUpdatedValues(audience_state_output);
      // eslint-disable-next-line
    }, [isSaved, unsavedModalIsOpen]);
  
    return updatedValues;

}
